'use client'
import { createContext, PropsWithChildren } from 'react'
import { PageSources } from '@/app/page.types'
import { Site_Settings } from '@/src/generated/graphql'

export type DirectusContextType = {
  SITE_SETTINGS: Partial<Site_Settings>
  PAGE_DATA: PageSources
}

export const DirectusContext = createContext<DirectusContextType>({
  PAGE_DATA: {},
  SITE_SETTINGS: {},
})

export const DirectusContextProvider = ({
  children,
  ...props
}: PropsWithChildren<DirectusContextType>) => {
  return <DirectusContext.Provider value={props}>{children}</DirectusContext.Provider>
}
